import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import tinyColor from 'tinycolor2';
/**
 * Show a card with a list of fields in it. You need to provide an object as the `item` prop and then a list of fields from within the object to be rendered.
 * You can also provide an optional `renderField` function to customize how fields are rendered.
 * @export
 *
 * @example
 * ```
 *  <ItemListCard
 *      title="System"
 *      item={{
 *          "hvac": {
 *              "value": 250,
 *              "percentage": 15
 *          },
 *          "lighting": {
 *              "value": 250,
 *              "percentage": 15
 *          },
 *          "elevators": {
 *              "value": 250,
 *              "percentage": 15
 *          },
 *          "fire alarm": {
 *              "value": 250,
 *              "percentage": 15
 *          }
 *      }}
 *      renderSubTitle={() => {
 *          return (<div className="sample-subtitle">Savings (AED)</div>)
 *      }}
 *      fields={["hvac", "lighting", "elevators", "fire alarm"]}
 *      renderField={(item, field, key) => {
 *          return (<div className="sample-item-field" key={key}>
 *              <div className="label">{field.toUpperCase()}</div>
 *              <div className="value">
 *                  <div className="amount">{item[field].value}</div>
 *                  <div className="percentage">{item[field].percentage}%</div>
 *              </div>
 *          </div>)
 *      }}
 *      backgroundColor="rgb(209 148 250)"
 *  />
 * ```
 *
 */
const ItemListCard = (props) => {
    // props
    let { title, renderSubTitle, item, fields, renderField, backgroundColor, className } = props;
    // styles
    let headerStyles = {};
    let bodyStyles = {};
    // background
    if (backgroundColor && backgroundColor.trim().length > 0) {
        // header
        let _bgColor = tinyColor(backgroundColor);
        headerStyles = {
            backgroundColor: backgroundColor,
            color: _bgColor.isDark() ? "var(--white)" : "var(--primaryTextColor)"
        };
        // body
        let _bodyBg = _bgColor.lighten();
        bodyStyles = {
            backgroundColor: _bodyBg.toHexString(),
            color: _bodyBg.isDark() ? "var(--white)" : "var(--primaryTextColor)"
        };
    }
    return (_jsxs("div", { className: classNames("uxpcore_itemlistcard uxp-item-list-card", className), children: [_jsxs("div", { className: "uxpcore_itemlistcard__header header", style: headerStyles, children: [_jsx("div", { className: "uxpcore_itemlistcard__title title", children: title }), renderSubTitle && renderSubTitle()] }), _jsx("div", { className: "uxpcore_itemlistcard__body body", style: bodyStyles, children: fields.map((field, key) => {
                    if (renderField) {
                        return renderField(item, field, key);
                    }
                    let fieldValue = item[field];
                    if (typeof item[field] == "object") {
                        fieldValue = JSON.stringify(item[field]);
                    }
                    return (_jsxs("div", { className: "uxpcore_itemlistcard__field item-field", id: key.toString(), children: [_jsx("div", { className: "uxpcore_itemlistcard__label label", children: field }), _jsx("div", { className: "uxpcore_itemlistcard__value value", children: fieldValue })] }, key));
                }) })] }));
};
export default ItemListCard;
